import LecturerWorkloadSummaryResourceModel from '../../generated/types/model/resource/LecturerWorkloadSummaryResourceModel';

export default class LecturerWorkloadSummaryResourceViewModel extends LecturerWorkloadSummaryResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
